// Registration used to write a literal "." into a name left blank, so across
// existing data "." means "no name" and must not reach the avatar as initials.
const PLACEHOLDER_NAME = '.'

// Digits and symbols that never appear in a name. Blocking these rather than
// allow-listing letters keeps every script usable - Łukasz, Nguyễn and Ngā are
// names too. '?' is deliberately absent: the VARCHAR name columns substitute it
// for letters their code page cannot store, so rejecting it would lock those
// users out of being saved at all.
const NAME_DISALLOWED = /[0-9<>@#$%^&*_=+[\]{}\\|/~`!";:,]/
// A value made only of spaces, hyphens, apostrophes or full stops is not a name.
const NAME_HAS_LETTER = /\p{L}/u

function trimName(value) {
  return value === null || value === undefined ? '' : String(value).trim()
}

function cleanName(value) {
  const trimmed = trimName(value)
  return trimmed === PLACEHOLDER_NAME ? '' : trimmed
}

// True for an empty value so `required` owns that message instead of both firing.
function isPersonName(value) {
  const trimmed = trimName(value)
  if (!trimmed) return true
  return !NAME_DISALLOWED.test(trimmed) && NAME_HAS_LETTER.test(trimmed)
}

// A display name may be a full name ('Bruce Wayne') or a username ('bruce'), so
// take a letter from each of the first two words when there are two, and two
// letters from the word when there is one.
function initialsFromWords(value) {
  const words = value.split(/\s+/).filter(Boolean)
  if (words.length > 1) return (words[0][0] + words[1][0]).toUpperCase()
  return value.slice(0, 2).toUpperCase()
}

// Both names -> a letter of each. One name -> its first two letters. Neither ->
// the display name, then '?'.
function getInitials({ firstName, lastName, displayName } = {}) {
  const first = cleanName(firstName)
  const last = cleanName(lastName)
  if (first && last) return (first[0] + last[0]).toUpperCase()

  const single = first || last
  if (single) return single.slice(0, 2).toUpperCase()

  const display = cleanName(displayName)
  return display ? initialsFromWords(display) : '?'
}

function getFullName({ firstName, lastName, displayName } = {}) {
  const parts = [cleanName(firstName), cleanName(lastName)].filter(Boolean)
  if (parts.length) return parts.join(' ')
  return cleanName(displayName) || '?'
}

export { cleanName, isPersonName, getInitials, getFullName }
